import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

import { SNP_BUCKETS, getBucketColors } from './ClonalityHeatmapCell';

function ClonalityHeatmapLegend({ showColors }) {
  const theme = useTheme();
  const bucketColors = getBucketColors(theme);

  return (
    <Box sx={{ mt: 0, px: 0.5, py: 0.25, display: 'inline-flex', maxWidth: '100%' }}>
      <Stack
        direction="row"
        spacing={1.5}
        useFlexGap
        sx={{ alignItems: 'center', flexWrap: 'wrap' }}
      >
        {SNP_BUCKETS.map((bucket, index) => (
          <Stack
            key={bucket.label}
            direction="row"
            spacing={0.5}
            alignItems="center"
            sx={{ px: 0.25, py: 0.25 }}
          >
            {showColors && (
              <Box
                sx={{
                  width: 14,
                  height: 12,
                  border: 1,
                  borderColor: 'divider',
                  borderRadius: 0.5,
                  backgroundColor: bucketColors[index]
                }}
              />
            )}
            <Typography variant="caption" color="text.secondary" noWrap>
              {bucket.label}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Box>
  );
}

ClonalityHeatmapLegend.propTypes = {
  showColors: PropTypes.bool
};

ClonalityHeatmapLegend.defaultProps = {
  showColors: true
};

export default ClonalityHeatmapLegend;
